import React from 'react';
import styles from '../../styles/WeatherInfo.module.scss';
import { WeatherData } from '../../types/WeatherData';

interface WeatherInfoProps {
  weatherData: WeatherData;
}

const WeatherInfo: React.FC<WeatherInfoProps> = ({ weatherData }) => {
  const temp = Math.round(weatherData.temp_f);
  const feels = Math.round(weatherData.feelslike_f);

  return (
    <div className={styles['weather-info']}>
      <div className={styles['temp-row']}>
        <span className={styles['temp-value']}>{temp}°</span>
        <img
          src={weatherData.condition.icon}
          alt={weatherData.condition.text}
          className={styles['cond-icon']}
        />
      </div>

      <div className={styles['cond-text']}>{weatherData.condition.text}</div>
      <div className={styles['feels-like']}>Feels like {feels}°</div>
      <p>Humidity: {weatherData.humidity}%</p>
      <p>Wind: {weatherData.wind_mph} mph</p>
    </div>
  );
};

export default WeatherInfo;
